/**
 * @description 季报高光时刻组件 - 动态分发
 * 根据 year prop 选择对应年份版本的组件
 */
import React from 'react';
import HighlightMoment2025 from '../../v1/components/HighlightMoment';
import HighlightMoment2026 from '../../v2/components/HighlightMoment';

interface IHighlightMomentProps extends IBaseProps {
  year?: number;
  quarterChars?: string;
  report?: IQuarterReportDetails | null;
}

const HighlightMoment: React.FC<IHighlightMomentProps> = ({ year, ...rest }) => {
  const Component = year === 2025 ? HighlightMoment2025 : HighlightMoment2026;
  return <Component year={year} {...rest} />;
};

export default HighlightMoment;
